import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { RouteComponentProps, Switch } from 'react-router-dom';

import { inject, bind } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import { VorgangStore } from '../../stores/VorgangStore';
import { IObjekt, IOrt } from '../../models/ApiTypes';
import VorgangDetails from './VorgangDetails';
import PrivateRoute from '../site/PrivateRoute';
import ArbeitsmittelAuswahl from '../arbeitsmittel/ArbeitsmittelAuswahl';
import ObjektAuswahl from '../objekte/ObjektAuswahl';
import ObjektAnlegenSEP from '../objekte/ObjektAnlegenSEP';
import { Glyphicon } from 'react-bootstrap';
import { AuftragStore } from '../../stores/AuftragStore';
import ObjektAnlegenAGT from '../objekte/ObjektAnlegenAGT';
import ObjektAnlegenBPS from '../objekte/ObjektAnlegenBPS';
import ObjektAnlegenDMG from '../objekte/ObjektAnlegenDMG';

interface IVorgangDetailRouterProps {
  vorgangId: string;
}

@observer
export default class VorgangDetailRouter extends React.Component<RouteComponentProps<IVorgangDetailRouterProps>, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;
  @inject(AuftragStore) auftragStore: AuftragStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable vorlageAbgefragt = false;

  componentDidMount() {
    this.refreshVorgang();
  }

  @bind @action vorlageAbgefragtHandler(abgefragt: boolean) {
    this.vorlageAbgefragt = abgefragt;
  }

  @bind refreshVorgang() {
    this.vorgangStore.loadVorgang(this.props.match.params.vorgangId, this.vorlageAbgefragtHandler);
  }

  componentWillReceiveProps(nextProps: RouteComponentProps<IVorgangDetailRouterProps>) {
    this.vorgangStore.loadVorgang(nextProps.match.params.vorgangId, this.vorlageAbgefragtHandler);
  }

  @bind async handleArbeitsmittelSetAuswahl(ort: IOrt) {
    const { vorgangId } = this.props.match.params;
    const response = await this.apiStore.vorgangOrtSetzen(vorgangId, ort.ortguid);
    if (response.ok && response.json.success) {
      this.uiStore.navigateTo(this.props.match.url);
    }
  }

  @bind async handleObjektAuswahl(objekt: IObjekt) {
    const { vorgangId } = this.props.match.params;
    const response = await this.apiStore.vorgangObjektSetzen(vorgangId, objekt.objektguid);
    if (response.ok && response.json.success) {
      this.uiStore.navigateTo(this.props.match.url);
    }
  }

  @bind async handleAddObjekt(objekt: Partial<IObjekt>) {
    const { vorgangId } = this.props.match.params;
    const response = await this.apiStore.objektAnlegen(objekt, undefined, vorgangId);
    if (response.ok && response.json.success) {
      this.refreshVorgang();
      this.uiStore.navigateTo(this.props.match.url);
    }
  }

  @bind async handleObjektAuswahlAufheben() {
    const { vorgangId } = this.props.match.params;
    if ((this.vorgangStore.vorgang) && (this.vorgangStore.vorgang.objekte)) {
      for (let i = 0; i < this.vorgangStore.vorgang.objekte.length; i++) {
        const response = await this.apiStore.vorgangObjektEntfernen(vorgangId, this.vorgangStore.vorgang.objekte[i].objektguid);
        if (!response.ok) {
          break;
        }
      }
      this.refreshVorgang();
    }
  }

  @bind async handleKorrekturvorgangAnlegen(vorgangId: string) {
    const response = await this.apiStore.vorgangKorrigieren(vorgangId);
    if (response.ok && this.vorgangStore.vorgang) {
      this.uiStore.navigateTo(`/auftrag/${this.vorgangStore.vorgang.anr}/vorgang/${response.json.success}`);
    }
  }

  render() {
    const { url } = this.props.match;
    const {vorgang, vorlage, objekte} = this.vorgangStore;
    return (
      <div className="vorgang-details">
        {!(vorgang && this.vorlageAbgefragt && objekte) ? <div className="maxwidth">lade Dienstleistung...</div> : (
          <div>

            <h3>
              Dienstleistung {vorlage ? vorlage.dienstleistung : vorgang.kuerzel_dienstleistung}
            </h3>
            <h3>
              Vorgang Nr. {vorgang.sortierung}: {vorgang.name}
              {vorgang.korrekturvorgang && (
                <span> (<Glyphicon glyph="pencil" /> Korrektur) </span>
              )}
            </h3>

            <Switch>
              <PrivateRoute path={`${url}/arbeitsmittel`} render={() => (
                <ArbeitsmittelAuswahl
                  title={'Auswahl des Arbeitsmittel-Sets'}
                  kategorie={vorgang.arbeitsmitteltyp}
                  onArbeitsmittelSetAuswahl={this.handleArbeitsmittelSetAuswahl}
                />
              )} />

              <PrivateRoute path={`${url}/objekte`} exact={true} render={() => (
                <ObjektAuswahl
                  kategorie={vorgang.objekttyp}
                  onObjektAuswahl={this.handleObjektAuswahl}
                />
              )} />

              <PrivateRoute path={`${url}/objekte/anlegen/ses`} exact={true} render={() => (
                <ObjektAnlegenSEP onAddObjekt={this.handleAddObjekt} />
              )} />

              <PrivateRoute path={`${url}/objekte/anlegen/agt`} exact={true} render={() => (
                <ObjektAnlegenAGT onAddObjekt={this.handleAddObjekt} />
              )} />

              <PrivateRoute path={`${url}/objekte/anlegen/bps`} exact={true} render={() => (
                <ObjektAnlegenBPS onAddObjekt={this.handleAddObjekt} />
              )} />

              <PrivateRoute path={`${url}/objekte/anlegen/dmg`} exact={true} render={() => (
                <ObjektAnlegenDMG onAddObjekt={this.handleAddObjekt} />
              )} />

              <PrivateRoute render={() => (
                <VorgangDetails
                  vorgang={vorgang}
                  vorlage={vorlage}
                  objekte={objekte}
                  onKorrekturvorgangAnlegen={this.handleKorrekturvorgangAnlegen}
                  onObjektAuswahlAufheben={this.handleObjektAuswahlAufheben}
                />
              )}/>
            </Switch>

          </div>
        )}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorgaenge/VorgangDetailRouter.tsx